import Icon, { IconProps } from './Icon';

import SearchIcon from '../../../assets/icons/search.svg?react';

const Search: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <SearchIcon />
    </Icon>
  );
};

export default Search;
